import axios from 'axios';

export default (getOptions) => ({
    FetchResourceBundle: (data) => axios.post('/api/utils/resources/bundle/fetch', data, getOptions()),
});
